export default {
    title: "月結單下載",
    search: "選擇日期：",
    place1: "開始時間",
    place2: "結束時間",
    table1: "日期",
    table2: "上傳日期",
    table3: "總月結單",
    table4: "網上月結單",
    table5: "月結單發票",
    downloadBtn: "下載",
}